export default __webpack_public_path__ + "static/media/AAA.ee43462c.png";